import { GraphQLClient } from "graphql-request";
import { getSdk } from "./sdk";
import { apiUrl } from "./url";

export const defaultClient = new GraphQLClient(apiUrl(), { fetch });

export default getSdk(defaultClient);
